import { slowCn } from '@unifyapps/ui/lib/utils';
import type { CSSProperties, ReactNode } from 'react';

export function PageWorkspace({
  children,
  className,
  style,
  isMobile,
  ...rest
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  isMobile?: boolean;
}) {
  return (
    <main
      className={slowCn(
        'ua-page-workspace bg-workspace flex min-h-0 flex-1 flex-col overflow-hidden',
        // only apply relative positioning on mobile; on mobile, absolutely positioned components
        // need to be contained within the workspace bounds to prevent them from covering the footer
        // on web, if we add relative to body/main, absolutely positioned components will take their positioning from
        // body instead of window, which changes the expected behavior
        isMobile && 'relative',
        className,
      )}
      data-name="workspace"
      style={style}
      {...rest}
    >
      {children}
    </main>
  );
}
